import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useI18n, SUPPORTED } from "@/i18n";

export default function LanguageSwitcher({ compact = false, onNavigate }) {
  const { lang } = useI18n();
  const location = useLocation();
  const navigate = useNavigate();

  const buildTargetPath = (target) => {
    const parts = location.pathname.split("/").filter(Boolean);
    if (SUPPORTED.includes(parts[0])) {
      parts[0] = target;
    } else {
      parts.unshift(target);
    }
    return "/" + parts.join("/") + (location.hash || "");
  };

  const switchTo = (target) => {
    if (target === lang) return;
    const path = buildTargetPath(target);
    // Preserve scroll on language change
    navigate(path, { replace: false, preventScrollReset: true });
    if (onNavigate) onNavigate();
  };

  return (
    <div
      className={`inline-flex items-center rounded-full border border-white/10 bg-white/5 backdrop-blur ${
        compact ? "p-0.5" : "p-1"
      }`}
      role="group"
      data-testid="language-switcher"
    >
      {SUPPORTED.map((code) => {
        const active = code === lang;
        return (
          <button
            key={code}
            type="button"
            onClick={() => switchTo(code)}
            data-testid={`lang-btn-${code}`}
            aria-pressed={active}
            className={`${compact ? "px-2.5 py-1 text-[11px]" : "px-3 py-1.5 text-xs"} rounded-full font-medium uppercase tracking-[0.18em] transition ${
              active
                ? "bg-[#C9F14B] text-[#0B0F14] shadow"
                : "text-[#c8cdd6] hover:text-white"
            }`}
          >
            {code}
          </button>
        );
      })}
    </div>
  );
}
